import { interval } from "rxjs";
import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"

export class DataSummaries{
    static async getAllDayValues(DataDate: Date){
        let Exclude =  {0:'',1:'',2:'',3:'',4:'', 5:''};;
        return await AppUsers.getMyUser().then((user) => {
            
            if(user.sysId == undefined){
                console.log('no user')
                return {};
            }
            
            
            return DataSafe.getAllDayValues(user.sysId, DataDate, Exclude ).then((res) => {
                let myAttributeNames = DataSafe.myAttributesDe();
                //console.log(myAttributeNames)
                /* @ts-ignore */
                let retArray = {};
                for(var i=0; i < res.length; i++){
                    let retRow = res[i];
                    /* @ts-ignore */
                    if((retRow["valueTSto"] == 0)
                    /* @ts-ignore */
                        && retRow["value"] != false){
                        let DateFrom = new Date();
                        DateFrom.setTime(retRow["valueTSfrom"]);
                        /* @ts-ignore */
                        retRow["DateFrom"] = DateFrom;
                        /* @ts-ignore */
                        retRow["timeFrom"] = DateFrom.toLocaleTimeString('de-DE', { hour: '2-digit', minute:'2-digit' });

                        let DateTo = new Date();
                        DateTo.setTime(retRow["valueTSto"]);
                        /* @ts-ignore */
                        retRow["DateTo"] = DateTo;
                        /* @ts-ignore */
                        retRow["timeTo"] = DateTo.toLocaleTimeString('de-DE', { hour: '2-digit', minute:'2-digit' });

                        let myAttributeName = myAttributeNames[retRow["attribute"]].split("_");
                        //console.log(myAttributeName)
                        /* @ts-ignore */
                        if(typeof retArray[myAttributeName[0]] == 'undefined')retArray[myAttributeName[0]] = {};
                        /* @ts-ignore */
                        if(typeof retArray[myAttributeName[0]][myAttributeName[1]] == 'undefined')retArray[myAttributeName[0]][myAttributeName[1]] = [];

                        
                        /* @ts-ignore */
                        retArray[myAttributeName[0]][myAttributeName[1]].push(retRow);
                        /* @ts-ignore */
                        //console.log(retArray);
                    }
                }
                /* @ts-ignore */
                //console.log(retArray);
                /* @ts-ignore */
                return retArray;
            })
        })
    }
    static async getToAll(opt: String){
        return await AppUsers.getMyUser().then((user) => {
            //getDataAttributeNumbers
            let attributeNbs = DataSafe.getDataAttributeNumbers()
            return DataSafe.getAllValuesToAttributeNbs(user.sysId, attributeNbs, false).then((res) => {
                /* @ts-ignore */
                let ret = {};
                switch(opt){
                    case 'withDayInfos':
                        let separated = DataSummaries.asDBdate(res);
                        ret = DataSummaries.addPositionInfo(separated.hasPeriod);
                        /* @ts-ignore */
                        ret.hasData=separated.hasData;
                        //console.log(ret)
                        break;
                }
                /* @ts-ignore */
                //console.log(res)
                /* @ts-ignore */
                return ret;
            })
        })
    }

    static async getPredictionSummary(){

    }

    static async getDataToTimerange(From: Date, To: Date ){
        return await AppUsers.getMyUser().then((user) => {
            return DataSafe.getValuesToDaySortedTimeRange(user.sysId, From, To).then((res) => {
                //console.log(res)
                /* @ts-ignore */
                let myAttributeNames = DataSafe.myAttributesDe();
                //console.log(myAttributeNames)
                let resKeys = Object.keys(res)
                let SortedResult = {};
                /* @ts-ignore */
                let foundGroups = {};
                for(var i = 0; i < resKeys.length; i++){
                    let KeyDate = new Date()
                    /* @ts-ignore */
                    KeyDate.setTime(parseInt(resKeys[i]))
                    let DayKey = DataSummaries.convertDateDB(KeyDate)
                    //console.log(DayKey)

                    /* @ts-ignore */
                    let AttributeNbKeys = Object.keys(res[resKeys[i]])
                    for(var k = 0; k < AttributeNbKeys.length; k++){
                        let AttrNb = AttributeNbKeys[k]
                        /* @ts-ignore */
                        let AttrName = myAttributeNames[AttrNb]
                        if(typeof AttrName != 'undefined'){
                            let splittedAttrName = DataSummaries.getAttrGropAndName(AttrName)
                            //console.log(splittedAttrName)
                            if(splittedAttrName != false){
                                /* @ts-ignore */
                                let SubTSkeys = Object.keys(res[resKeys[i]][AttributeNbKeys[k]])
                                for(var s=0; s < SubTSkeys.length; s++){
                                        /* @ts-ignore */
                                        let HandledRow = res[resKeys[i]][AttributeNbKeys[k]][SubTSkeys[s]][0];
           // console.log(HandledRow)
                                        
                                        if(HandledRow.value != false && HandledRow.valueTSto == 0){
                                            /* @ts-ignore */
                                            if(typeof foundGroups[splittedAttrName.group] == 'undefined'){
                                                /* @ts-ignore */
                                                foundGroups[splittedAttrName.group] = {}
                                            }
                                            /* @ts-ignore */
                                            if(typeof foundGroups[splittedAttrName.group][splittedAttrName.name] == 'undefined'){
                                                /* @ts-ignore */
                                                foundGroups[splittedAttrName.group][splittedAttrName.name] = []
                                            }
                                            /* @ts-ignore */
                                            if(splittedAttrName.group != 'Smart Wearables'){
                                                /* @ts-ignore */
                                                if(!foundGroups[splittedAttrName.group][splittedAttrName.name].includes(HandledRow.value))foundGroups[splittedAttrName.group][splittedAttrName.name].push(HandledRow.value)
                                            }
                                        

                                        
                                        // setup resultObject:
                                        /* @ts-ignore */
                                        if(typeof SortedResult[DayKey] == 'undefined'){
                                            /* @ts-ignore */
                                            SortedResult[DayKey] = {}
                                        }
                                        /* @ts-ignore */
                                        if(typeof SortedResult[DayKey][splittedAttrName.group] == 'undefined'){
                                            /* @ts-ignore */
                                            SortedResult[DayKey][splittedAttrName.group] = {}
                                        }
                                        /* @ts-ignore */
                                        if(typeof SortedResult[DayKey][splittedAttrName.group][splittedAttrName.name] == 'undefined'){
                                            /* @ts-ignore */
                                            SortedResult[DayKey][splittedAttrName.group][splittedAttrName.name] = []
                                        }
                                        
                                        /* @ts-ignore */
                                        SortedResult[DayKey][splittedAttrName.group][splittedAttrName.name].push(HandledRow)
                                    }
                                }

                            } // if spliitedNames
                        }
                    }
                }
                //let DateKeys = Object.keys(SortedResult)
                //console.log(DateKeys)
                //console.log(DateKeys.sort())
                return {
                    values:SortedResult,
                    foundGroups:foundGroups,
                }
            })
        });
    }

    static getAttrGropAndName(AttrName: String){
        let prefixPart = AttrName.split("_")
        if(prefixPart.length > 1){
            return {group:prefixPart[0], name:prefixPart[1]}
        }else{
            console.log('error:')
            console.log(AttrName)
            return false
        }
    }


    static asDBdate(valuerows: any){
        let attributeNumbers = [49,50,51,52];
        let ret = [];
        let retPeriod = [];
        for( var i=0; i<valuerows.length; i++){
            let valuerow = valuerows[i];
            let ValueDate = new Date();
            ValueDate.setTime(valuerow.valueTSfrom);
            if((valuerow.value == true) && (valuerow.valueTSto == 0)
               && attributeNumbers.includes( valuerow.attribute )){
                retPeriod.push(DataSummaries.convertDateDB(ValueDate)); 
            }else{
                ret.push(DataSummaries.convertDateDB(ValueDate)); 
            }
        }
        return {
            "hasData":ret,
            "hasPeriod":retPeriod,
        };
    }



    static async getPeriodDays(opt: String){
        return await AppUsers.getMyUser().then((user) => {
            return DataSafe.getAllValuesToAttributeNbs(user.sysId, [49,50,51,52], true).then((res) => {
                //console.log(res)
                /* @ts-ignore */
                let ret = {};
                switch(opt){
                    case 'withDayInfos':
                        ret = DataSummaries.addPositionInfo(DataSummaries.periodDayAsDBdate(res));
                                                                                                //console.log(ret)
                        break;
                    case 'lastFullCircle':
                        ret = DataSummaries.lastFullCircle(res);
                        break;
                }
                /* @ts-ignore */
                //console.log(res)
                /* @ts-ignore */
                return ret;
            })
        })
    }


    static lastFullCircle(valuerows: any){
        let helpSortetedToTS = {};
        for( var i=0; i<valuerows.length; i++){
            let valuerow = valuerows[i];
            if((valuerow.value == true) && (valuerow.valueTSto == 0)){
                let ValueDate = new Date();
                ValueDate.setTime(valuerow.valueTSfrom);
                ValueDate.setHours(12)
                ValueDate.setMinutes(0)
                ValueDate.setSeconds(0)
                ValueDate.setMilliseconds(0)
                let value = 0;
                switch(valuerow.attribute){
                    case 49:
                        value = 1;
                        break;
                    case 50:
                        value = 2;
                        break;
                    case 51:
                        value = 3;
                        break;
                    case 52:
                        value = 4;
                        break;
                    
                }
                /* @ts-ignore */
                helpSortetedToTS[ValueDate.getTime()] = value;
            }
        }
        let ret = Object.keys(helpSortetedToTS).sort().reduce(
            (obj, key) => { 
                /* @ts-ignore */
                obj[key] = helpSortetedToTS[key]; 
                return obj;
            }, 
            {}
          );
          return ret;

    }

    static periodDayAsDBdate(valuerows: any){
        
        let ret = [];
        for( var i=0; i<valuerows.length; i++){
            let valuerow = valuerows[i];
            if((valuerow.value == true) && (valuerow.valueTSto == 0)){
                let ValueDate = new Date();
                ValueDate.setTime(valuerow.valueTSfrom);
                ret.push(DataSummaries.convertDateDB(ValueDate)); 
            }
        }
        //console.log(ret)
        return ret;
    }

    static addPositionInfo(valArray: any){
        let Settings = DataSummaries.PredictedSettings();
        valArray.sort();
        let firstDaysTS = [];
        let lastDaysTS = [];
        let firstAndLastDayTS = [];
        let firstDays = [];
        let lastDays = [];
        let firstAndLastDay = [];
        /* @ts-ignore */
        let preOvulationDays = [];
        /* @ts-ignore */
        let ovulationDays = [];
        /* @ts-ignore */
        let postOvulationDays = [];
        let predictedNextOvulation = 0;

        for( var i=0; i<valArray.length; i++){
            let HDate = new Date(valArray[i]);
            let DayBefore = new Date();
            DayBefore.setTime(HDate.getTime()-24*60*60*1000);
            let DayAfter = new Date();
            DayAfter.setTime(HDate.getTime()+24*60*60*1000);

            let isFirstDay = false;
            let isLastDay = false;

            if(!valArray.includes(DataSummaries.convertDateDB(DayBefore))){
                isFirstDay = true;
                firstDaysTS.push(HDate.getTime());
                firstDays.push(DataSummaries.convertDateDB(HDate));

                let OvulationInfos = DataSummaries.getPredictedOvulationDays(HDate);
                /* @ts-ignore */
                preOvulationDays = preOvulationDays.concat(OvulationInfos.preOvulationDays);
                /* @ts-ignore */
                ovulationDays = ovulationDays.concat(OvulationInfos.ovulationDays);
                /* @ts-ignore */
                postOvulationDays = postOvulationDays.concat(OvulationInfos.postOvulationDays);
                // <- PastPredictionOvulation
            }
            if(!valArray.includes(DataSummaries.convertDateDB(DayAfter))){
                isLastDay = true;
                lastDaysTS.push(HDate.getTime());
                lastDays.push(DataSummaries.convertDateDB(HDate));
            }
            if(!valArray.includes(DataSummaries.convertDateDB(DayBefore))
            && !valArray.includes(DataSummaries.convertDateDB(DayAfter))){
                firstAndLastDayTS.push(HDate.getTime());
                firstAndLastDay.push(DataSummaries.convertDateDB(HDate));
            }

            
        }

        let lastFirst = Math.max(...firstDaysTS);
        let firstPredicted = DataSummaries.getFuturePredictedValues(lastFirst,lastFirst+180*24*60*60*1000,9)
        
        /* @ts-ignore */
        preOvulationDays = preOvulationDays.concat(firstPredicted.predictedOvulationDays.preOvulationDays.flat());
        /* @ts-ignore */
        ovulationDays = ovulationDays.concat(firstPredicted.predictedOvulationDays.ovulationDays.flat());
        /* @ts-ignore */
        postOvulationDays = postOvulationDays.concat(firstPredicted.predictedOvulationDays.postOvulationDays.flat());
        /* @ts-ignore */
        if(firstPredicted.predictedOvulationDays.nextOvulation > 0)predictedNextOvulation=firstPredicted.predictedOvulationDays.nextOvulation
        
        return {
            "alldays":valArray,
            "firstDaysTS":firstDaysTS,
            "lastDaysTS":lastDaysTS,
            "firstAndLastDayTS":firstAndLastDayTS,
            "firstDays":firstDays,
            "lastDays":lastDays,
            "firstAndLastDay":firstAndLastDay,
            /* @ts-ignore */
            "preOvulationDays":preOvulationDays,
            /* @ts-ignore */
            "ovulationDays":ovulationDays,
            /* @ts-ignore */
            "postOvulationDays":postOvulationDays,
            /* @ts-ignore */
            "predictedPeriodDays":firstPredicted.predictedPeriodDays,
            /* @ts-ignore */
            "predictedPeriodFirstDaysTS":firstPredicted.predictedPeriodFirstDaysTS,
            "calculatedCycles":DataSummaries.CalculateCycle(firstDaysTS),
            "predictedNextOvulationTS":predictedNextOvulation
        }
    }



    static CalculateCycle(firstDaysTS: any){
        let ts = [...new Set(firstDaysTS)]
        ts.sort();
        
        let foundTimeSpans=[];
        let sum = 0;
        for(var i=1;i<ts.length;i++){
            /* @ts-ignore */
            let dist = (ts[i]-ts[i-1])/(24*60*60*1000);
            foundTimeSpans.push(dist)
            sum+=dist
        }
        
        return {
            "cycles":foundTimeSpans,
            "avgCycle":Math.round(sum/(ts.length-1))
        }
    }

    static PredictedSettings(){
        return {
            "dayNbPreOvulationStart": -16,
            "dayNbOvulation": -14,
            "dayNbPostOvulationEnds": -12,
        }
    }

    static Cyclelength(){
        return 29;
    }

    static Periodlength(){
        return 5;
    }


    static getFuturePredictedValues(lastPeriodStartTS: number, 
                                    PredictionStartTS:number,
                                    monthes: number){
        let Settings = DataSummaries.PredictedSettings();
        let Cycle = DataSummaries.Cyclelength();
        /* @ts-ignore */
        let predictedPeriodDays = [];
        /* @ts-ignore */
        let predictedPeriodFirstDaysTS = [];
        let predictedOvulationDays = {"preOvulationDays":[],
                                      "ovulationDays":[],
                                      "postOvulationDays":[],
                                      "nextOvulation":0}
        
        

        let LastFirstPeriodDay = new Date()
        LastFirstPeriodDay.setTime(lastPeriodStartTS)

        let PredictionStartDay = new Date()
        PredictionStartDay.setTime(PredictionStartTS)

        let FirstPredictedPeriodDay = new Date()
        FirstPredictedPeriodDay.setTime(LastFirstPeriodDay.getTime() + (Cycle) * 24*60*60*1000)
        let StartDay = FirstPredictedPeriodDay;

        for(var m=1;m<monthes;m++){
            // Do Ovulation before
            /* @ts-ignore */
            predictedPeriodDays = predictedPeriodDays.concat(DataSummaries.getPredictedPeriodDays(StartDay).flat())

            let predictedOvulation = DataSummaries.getPredictedOvulationDays(StartDay);
            /* @ts-ignore */
            predictedOvulationDays.preOvulationDays.push(predictedOvulation.preOvulationDays)
            /* @ts-ignore */
            predictedOvulationDays.ovulationDays.push(predictedOvulation.ovulationDays)
            /* @ts-ignore */
            predictedOvulationDays.postOvulationDays.push(predictedOvulation.postOvulationDays)
            predictedPeriodFirstDaysTS.push(StartDay.getTime());

            if(predictedOvulation.nextOvulation >0)predictedOvulationDays.nextOvulation = predictedOvulation.nextOvulation;

            StartDay.setTime(StartDay.getTime() + (Cycle)  * 24*60*60*1000)
        }
        
        return {
            "predictedPeriodDays":predictedPeriodDays,
            "predictedPeriodFirstDaysTS":predictedPeriodFirstDaysTS,
            "predictedOvulationDays":predictedOvulationDays,
        }

        

    }


    static getPredictedOvulationDays(StartDate: Date){
        let Today = new Date();
        let nextOvulation = 0;

        let preOvulationDays = [];
        let ovulationDays = [];
        let postOvulationDays = [];

        let Settings = DataSummaries.PredictedSettings();
        let WorkDate = new Date(StartDate.getTime() + Settings.dayNbPreOvulationStart * 24 * 60 * 60 * 1000);
        preOvulationDays.push(DataSummaries.convertDateDB(WorkDate));
        let OvCt = Math.abs(Settings.dayNbPreOvulationStart - Settings.dayNbOvulation);
        for(var d = 1; d < OvCt; d++){
            WorkDate = new Date(WorkDate.getTime() + 24 * 60 * 60 * 1000);
            preOvulationDays.push(DataSummaries.convertDateDB(WorkDate));
        }
        WorkDate = new Date(WorkDate.getTime() + 24 * 60 * 60 * 1000);
        ovulationDays.push(DataSummaries.convertDateDB(WorkDate));

        if((WorkDate.getTime() >= Today.getTime())
            && (WorkDate.getTime() < (Today.getTime()+(DataSummaries.Cyclelength()*24*60*60*1000) ))
            && (nextOvulation == 0)){
                nextOvulation = WorkDate.getTime();
        }

        WorkDate = new Date(WorkDate.getTime() + 24 * 60 * 60 * 1000);
        postOvulationDays.push(DataSummaries.convertDateDB(WorkDate));
        let OvCt2 = Math.abs(Settings.dayNbOvulation - Settings.dayNbPostOvulationEnds)
        for(var d = 1; d < OvCt2; d++){
            WorkDate = new Date(WorkDate.getTime() + 24 * 60 * 60 * 1000);
            postOvulationDays.push(DataSummaries.convertDateDB(WorkDate));
        }

        return {
            "preOvulationDays":preOvulationDays,
            "ovulationDays":ovulationDays,
            "postOvulationDays":postOvulationDays,
            "nextOvulation":nextOvulation,
        }
    }


    static getPredictedPeriodDays(StartDay: Date){
        let Periodlength = DataSummaries.Periodlength();
        let predictedPeriodDays = [];
        let PDate = new Date()
        PDate.setTime(StartDay.getTime())
        for(var p=0;p<Periodlength;p++){
            predictedPeriodDays.push(DataSummaries.convertDateDB(PDate))
            PDate.setTime(PDate.getTime() + 24*60*60*1000)
        }
       
        return predictedPeriodDays;
    }

    
    static async getDateToAttributeNBsInTimerange(attributeNumbers: Array<number>, FromDate: Date, ToDate: Date){
        return await AppUsers.getMyUser().then((user) => {
            return DataSafe.getDayValuesToAttributesWithNamesTimeRange(user.sysId, attributeNumbers, FromDate, ToDate).then((res) => {
                //console.log(res)
                return res
            })
        })
    }


    static async getAllValuesforCSVExport(){
        return await AppUsers.getMyUser().then((user) => {
            return DataSafe.getAllValuesWithAttributeNames(user.sysId,'dateToString').then((res) => {
                let ret = [];
                if(res.length > 0){
                    let keys = Object.keys(res[0]);
                    ret.push(keys);
                    // do this loop to keep col to name clean
                    for(var i=0;i<res.length;i++){
                        let helprow = [];
                        for(var k = 0; k < keys.length; k++){
                            /* @ts-ignore */
                            helprow[k] = '"'+res[i][keys[k]]+'"';
                        }
                        ret.push(helprow.join(','));
                    }
                }
                return ret.join('\n');
            })
        })
    }

    static reConvertCalDate(calDate: String){
        calDate = calDate.substring(3, 13);
        let dateParts = calDate.split("-");
        return dateParts[0]+'-'+dateParts[1]+'-'+dateParts[2];
    }

    static convertDateDB(ValueDate: Date){
        return ValueDate.getFullYear()+'-'+DataSummaries.leadingZero( ValueDate.getMonth()+1 )+'-'+DataSummaries.leadingZero(ValueDate.getDate());
    }

    static leadingZero(val: number){
        //console.log(val);
        return (val < 10 ? '0' : '') + val;
    }
}